import { render, staticRenderFns } from "./LanguageSelectDropdown.vue?vue&type=template&id=bfd07b70&scoped=true&"
import script from "./LanguageSelectDropdown.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectDropdown.vue?vue&type=style&index=0&id=bfd07b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd07b70",
  null
  
)

export default component.exports